<template>
    <CContainer>
        <CRow>
            <CCol col="12" class="d-flex overflow-auto px-0">
                <CButtonGroup>
                    <CButton :color="filters.duration === 0 ? 'info' : 'outline-info'" class="mfe-1" @click="changeDuration(0)">امروز</CButton>
                    <CButton :color="filters.duration === 1 ? 'info' : 'outline-info'" class="mfe-1" @click="changeDuration(1)">دیروز</CButton>
                    <CButton :color="filters.duration === 6 ? 'info' : 'outline-info'" class="mfe-1" @click="changeDuration(6)">هفت روز گذشته</CButton>
                    <CButton :color="filters.duration === 29 ? 'info' : 'outline-info'" class="mfe-1" @click="changeDuration(29)">سی روز گذشته</CButton>
                    <CButton :color="filters.duration === null ? 'info' : 'outline-info'" class="mfe-1" @click="changeDuration(null)">دلخواه</CButton>
                </CButtonGroup>
                 <div role="group" class="form-group datepicker">
                    <datePicker
                        :placeholder="$t('attributes.receipt_date_from')"
                        :clearable="true"
                        :range="true"
                        :show="modal.show"
                        format="YYYY-MM-DD"
                        display-format="jMMMM jD"
                        input-class="form-control"
                        v-model="filters.range"
                        custom-input="#range-inp"
                        @close="closeRange"
                    />
                </div>

                <input
                    id="range-inp"
                    type="text"
                    placeholder="YYYY/MM/DD"
                    style="display:none"
                />
            </CCol>
        </CRow>

        <ReportTable class="mt-2" />
    </CContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ReportTable, FilterIt, SortIt } from './partials'

export default {
    name: 'List',

    components: {
        ReportTable,
        FilterIt,
        SortIt,
    },

    data() {
        return {
            filters: {
                duration: 6,
                range: null
            },
            modal: {
                show: false,
            }
        }
    },

    computed: {
        ...mapGetters({
            current: 'user/current'
        }),
        user() {
            return this.current
        }
    },
    methods: {
        changeDuration(duration) {
            this.filters.duration = duration
            this.filters.start_date = null
            this.filters.end_date = null
            this.filters.range = null

            if (duration === null) {
                this.modal.show = true
                return
            }

            this.fetchReports()
        },
        closeRange() {
            this.modal.show = false
            if (! this.filters.range) {
                return
            }
            this.filters.start_date = this.filters.range[0]
            this.filters.end_date = this.filters.range[1]

            this.fetchReports()
        },
        ...mapActions({
            fetch: 'transaction/fetchReports',
        }),
        fetchReports() {
            this.fetch({
                ...this.filters
            })
        },
    }
}
</script>
